module.exports = __webpack_public_path__ + "img/14.0325cf60.png";